;(function () {
  'use strict'

  angular
    .module('contrast.security-controls')
    .factory(
      'securityControlsGuessTypeService',
      function securityControlsGuessTypeService(SECURITY_CONTROL_TYPES) {
        'ngInject'

        var guesses = {
          INPUT_VALIDATOR: ['check', 'valid'],
          SANITIZER: ['encode', 'strip', 'replace', 'filter', 'escape']
        }

        return {
          attemptToGuessType: attemptToGuessType
        }

        function attemptToGuessType(api) {
          api = getMethodSubstring(api)
          var keys = Object.keys(guesses)
          var i, len, key, match
          for (i = 0, len = keys.length; i < len; i++) {
            key = keys[i]
            match = guesses[key].find(function (str) {
              return api.toLowerCase().indexOf(str) > -1
            })
            if (match) {
              return SECURITY_CONTROL_TYPES[key].value
            }
          }
        }

        function getMethodSubstring(str) {
          var pieces = str.split('(')
          var first = pieces[0]
          var i = first.lastIndexOf('.')
          return first.substr(i + 1)
        }
      }
    )
})()
